import { TableField } from "../table-field";

export const fieldsParticipantes: TableField[] = [
    { key: 'CdCpfCnpjParticipante', label: 'CPF/CNPJ', tdClass: 'align-middle', thClass: 'text-center', sortable: true },
    { key: 'NmParticipante', label: 'Nome', tdClass: 'align-middle', thClass: 'text-center', sortable: true },
    { key: 'VlParticipacao', label: 'Valor Participação', tdClass: 'align-middle', thClass: 'text-center', sortable: true, formatter: (val: number) => val.toFixed(2).replace('.',',') },
    { key: "actions", label: "Ações", tdClass: ["align-middle", "col-actions", "min15rem"], thClass: "text-center", sortable: false }
]